/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Oktaacccreatefail3Inputs */

const en_auth_oktaacccreatefail3 = /** @type {(inputs: Auth_Oktaacccreatefail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to activate account.`)
};

/**
* | output |
* | --- |
* | "Failed to activate account." |
*
* @param {Auth_Oktaacccreatefail3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_oktaacccreatefail3 = /** @type {((inputs?: Auth_Oktaacccreatefail3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Oktaacccreatefail3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_oktaacccreatefail3(inputs)
});
export { auth_oktaacccreatefail3 as "auth_oktaAccCreateFail" }